import operations from '~/helpers/device-operations';
import { Camera } from './camera.model';

export class NOC extends Camera {

    minimumRebootFirmware = 139;
    minimumUnlockFirmware = 195;
    minimumHomekitResetFirmware = 3008000;
    hasSensitivityConfig = true;

    get deviceOperations() {
        return super.deviceOperations.concat([
            operations.installQRCode({ callback: this.installQRCode }),
            operations.resetQRCode({ callback: this.resetQRCode }),
            operations.homekitReset({ callback: this.homekitReset, disabled: this.isHomekitResetDisabled }),
            operations.associateUser({ disabled: this.associateUserDisabled }),
        ]);
    }

    get typeToDisplay() {
        if (this.hw_version === 217) {
            return 'NOC-S';
        }
        return 'NOC';
    }

}
